<div class="i-page-top">
  <div class="container">
    <!--Menu-->
    <div class="i-menu row align-items-center pt-3 pb-2">
      <div class="navbar-brand col-6 col-sm-8 col-md-6 col-lg-4 mr-auto py-2 px-0 text-center text-sm-left">
        <a href="#" routerLink="/home" aria-label="Private"
          ><img src="assets/img/logo-agro_cinza.svg" class="img-fluid my-auto" alt="Private"
        /></a>
      </div>
      <div class="col-6 col-sm-4 col-md-6 col-lg-8 ml-auto py-2">
        <app-menu></app-menu>
      </div>
    </div>
  </div>
</div>
<div class="i-page-content">
  <!--Call-Text-->
  <div
    class="i-main-call mt-3 py-5"
    [style]="
      'background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(' +
      (this.banner$ | async)?.arquivoUrl +
      ');' +
      'background-position-y: -80px !important;'
    ">
    <div class="container py-4 px-0">
      <div class="col-12 text-left px-2 px-lg-5 py-1">
        VALORIZE SEUS NEGÓCIOS AGRÍCOLAS, PECUÁRIOS E FLORESTAIS COM A PRIVATE +AGRO
      </div>
      <div class="i-subtitle col-12 col-md-7 text-left px-2 px-lg-5">
        Atuando na compra e venda de áreas para agricultura, pecuária, florestas de eucaliptos e pinus - a Private +Agro
        traz toda nossa expertise para um dos setores mais importantes para a economia brasileira.
        <br />
        <a data-toggle="modal" data-target="#modal_agro" class="btn btn-outline-light mt-4">CONHEÇA MAIS</a>
      </div>
    </div>
  </div>
  <div class="i-favorite container py-5">
    <div class="row text-center py-5">
      <h1 class="i-title mx-auto">
        IMÓVEIS +AGRO
        <ng-container *ngIf="search?.cidadeNome">
          <br />
          <div class="mt-4">
            {{ search?.cidadeNome }}
          </div>
        </ng-container>
      </h1>
    </div>
    <!-- BUSCA -->
    <div class="row pb-5">
      <div class="col-12 col-lg-9">
        <app-select-cidade [search]="search" [agro]="true"></app-select-cidade>
      </div>
      <!--Button-->
      <div class="col-12 col-lg-3 text-center">
        <button id="btnSearch" type="button" class="i-btn i-btn-cta" (click)="onChangeRoute()">VER RESULTADOS</button>
      </div>
    </div>
    <!-- -->
    <ng-container *ngIf="this.imoveis$ | async as resultPage">
      <ng-container *ngIf="resultPage?.items?.length > 0; else empty">
        <div class="row no-gutters">
          <div
            *ngFor="
              let property of resultPage.items
                | paginate
                  : {
                      id: 'pagination',
                      itemsPerPage: resultPage?.size,
                      currentPage: search.pag,
                      totalItems: resultPage?.total,
                    }
            "
            class="col-12 p-4">
            <app-box [property]="property" [boxType]="BoxType.Detail" [showMoreLessButton]="false"></app-box>
          </div>
        </div>
        <!--Pagination-->
        <div class="i-pagination row justify-content-center flex-column pt-3 pb-5">
          <pagination-controls
            (pageChange)="onChangePage($event)"
            id="pagination"
            class="mx-auto"
            [directionLinks]="false">
          </pagination-controls>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #empty>
      <div class="col i-text text-center my-3 py-5">
        <!-- SEM REGISTROS -->
        <h2 class="mb-2">Não há imóveis nesta categoria.</h2>
        Vá para busca e encontre o imóvei ideal para você.

        <div class="d-block mt-5">
          <a href="#" routerLink="/imoveis/status/venda" class="i-btn">Buscar imóveis</a>
        </div>
      </div>
    </ng-template>
  </div>
</div>
<!-- Modal -->
<div class="modal fade p-0" id="modal_agro" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
  <div class="i-modal-bg">
    <div class="modal-dialog mt-0" role="document">
      <div class="modal-content">
        <div class="row">
          <div class="i-title col-12 text-left">
            A PRIVATE IMÓVEIS AGORA TAMBÉM É PRIVATE+AGRO! CONHEÇA NOSSOS SERVIÇOS:
          </div>
          <div class="i-subtitle col-12 text-left pt-3 px-lg-5">
            <div class="i-hr"></div>
            A Private se dedica aos melhores bairros de Porto Alegre e São Paulo. Com uma estratégia focada, atraímos
            clientes ideais para nosso portfólio de imóveis. Fazendo parte do nosso time você encontrará o melhor lugar
            para este público.
          </div>
          <div class="row pb-5 pt-4 text-left px-lg-5">
            <div class="i-text col-6">
              <b>Compra e Venda Estratégicas:</b> Atuamos na compra e venda de áreas para agricultura, pecuária,
              florestas de eucaliptos e pinus.<br />
              <br />
              <b>Contratos Inteligentes:</b> Reconhecemos que o arrendamento ou parceria de áreas agrícolas, pecuárias,
              florestais podem ser uma solução vantajosa em diversos cenários. Nosso conhecimento de mercado e rede de
              contatos nos permitem encontrar as melhores opções de contratos agrários adaptados às suas necessidades
              específicas, seja para cultivo, pastoreio ou manejo florestal.<br />
              <br />
              <b>Avaliação Especializada:</b> Nossa equipe técnica avaliará minuciosamente as áreas em questão,
              considerando fatores cruciais para cada finalidade, como a qualidade do solo, disponibilidade de água,
              potencial produtivo e viabilidade para pecúaria, agricultura ou manejo florestal. Isso garante que você
              tenha uma avaliação precisa e justa.<br />
              <br />
              <b>Consultoria Jurídica Especializada:</b> Entendemos as complexidades legais envolvidas nas transações
              agrícolas. Nossa equipetrabalhaemconiuntocomrenomados especialistas jurídicos, oferecendo consultoria
              sólida em questões legais nacionais e internacionais relacionadas à compra, venda e arrendamento de áreas
              agrícolas, pecuárias e florestais
            </div>
            <div class="i-text col-6">
              Assessoria Financeira e Tributária: Temos expertise tributária para garantir que você esteja ciente de
              todas as implicações fiscais, permitindo que você tome decisões informadas e estratégicas.<br />
              <br />
              Assessoria Internacional: Se suas ambições se estendem além das fronteiras, a Private + AGRO está aqui
              para apoiar seus planos internacionais. Com conhecimento em mercados globais, podemos ajudá-lo a navegar
              por regulamentações, identificar oportunidades de investimento e facilitar transações internacionais,
              sempre com foco na eficiência e garantindo o melhor negócio.<br />
              <br />
              Assessoria em Seguros: Proteger seu investimento é crucial. Oferecemos orientação em relação a seguros
              agrícolas, garantindo que você esteja preparado para enfrentar desafios climáticos, desastres naturais e
              outros riscos que possam impactar suas operações.<br />
              <br />
              Linhas de Crédito e Financiamento: Sabemos que o acesso ao capital é fundamental para o crescimento no
              agronegócio. Através de nossa rede de parceiros financeiros, podemos ajudá-lo a encontrar as melhores
              opções de linhas de crédito e financiamento para adquirir silos galpões de armazenagem, maquinários e
              outros componentes essenciais para sua operação.
            </div>
          </div>
          <div class="col-12">
            <div class="i-hr"></div>
          </div>
          <div class="px-2 px-lg-5">
            <button type="submit" class="i-btn" data-dismiss="modal">VOLTAR</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
